import React from 'react';

import {ConvertorFieldTypeToDataType} from 'src/components/data-types/constants';

import {DropdownMenuItem} from '@pb/kit-component-dropdown-menu';

type Props = {
    dataType: string,
    handler: (value: string, item?: string) => void,
};

export const ItemsTypeList = ({dataType, handler}: Props) => {
    const {ARRAY, ARRAY_UNIQUE, REFERENCE, ...itemsTypeList} = ConvertorFieldTypeToDataType;

    return (
        <>
            {Object.entries(itemsTypeList)
                .toSorted((a, b) => a[0].localeCompare(b[0]))
                .map(([itemName, itemValue]) => {
                    return (
                        <DropdownMenuItem
                            key={itemValue}
                            caption={itemValue}
                            onClick={() => handler(dataType, itemName)}
                        />
                    );
                })}
        </>
    );
};
